import { Fragment } from 'react'
import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function AlertFeed({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 0 0;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 20px;display:flex;flex-direction:column;gap:10px")}>
        <button onClick={v.kTabConnect} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center")}>
          <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
        </button>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Alerts
        </span>
      </div>
      <div style={sx("flex:1;overflow:auto;padding:0 20px 24px;display:flex;flex-direction:column;gap:10px")}>
        {v.kNoAlerts ? (
          <>
            <div style={sx("margin-top:60px;display:flex;flex-direction:column;align-items:center;gap:10px;text-align:center;padding:0 24px")}>
              <span style={sx("width:56px;height:56px;border-radius:var(--radius-full);background:var(--bg-tertiary);display:flex;align-items:center;justify-content:center")}>
                <span style={sx("width:26px;height:26px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
                Nothing blocked yet
              </span>
              <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary)")}>
                Threats this phone blocks show up here.
              </span>
            </div>
          </>
        ) : null}
        {v.kAlertRows.map((row, i) => (
          <Fragment key={i}>
            <div style={sx("padding:16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-critical);display:flex;gap:12px;animation:gpop 250ms var(--ease-out)")}>
              <span style={sx("width:40px;height:40px;flex:none;border-radius:var(--radius-full);background:var(--bg-critical-subtle);display:flex;align-items:center;justify-content:center")}>
                <span style={sx("width:20px;height:20px;background:var(--text-critical);-webkit-mask:url(/assets/icons/threat-protection.svg) center/contain no-repeat;mask:url(/assets/icons/threat-protection.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:4px;min-width:0")}>
                <span style={sx("display:flex;justify-content:space-between;gap:8px;align-items:baseline")}>
                  <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
                    {row.title}
                  </span>
                  <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary);flex:none")}>
                    {row.time}
                  </span>
                </span>
                <span style={sx("font-size:var(--fs-xs);line-height:18px;color:var(--text-secondary)")}>
                  {row.detail}
                </span>
                <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary);margin-top:2px")}>
                  {row.shared}
                </span>
              </span>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  )
}
